import styled from 'styled-components'

export const ProgressBar = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 1px solid #ddd;
    height: 30px;
    width: 100%;
    border-radius: 3px;
    color: #333;
    text-align: center;
    line-height: 30px;
    transition: all 0.5s ease-in-out;
`

export const ProgressBarAnimation = styled.div`
    position: absolute;
    left: -46px;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: -1;

    background: -webkit-repeating-linear-gradient(
        145deg,
        #338ce4 1px,
        #97cafc 2px,
        #97cafc 11px,
        #338ce4 12px,
        #338ce4 20px
    );
    background: repeating-linear-gradient(
        -55deg,
        #338ce4 1px,
        #97cafc 2px,
        #97cafc 11px,
        #338ce4 12px,
        #338ce4 20px
    );

    -webkit-animation-name: animatedBg;
    -webkit-animation-duration: 1s;
    -webkit-animation-timing-function: linear;
    -webkit-animation-iteration-count: infinite;

    animation-name: animatedBg;
    animation-duration: 1s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;

    @-webkit-keyframes animatedBg {
        from {
            -webkit-transform: translateX(0);
        }
        to {
            -webkit-transform: translateX(46px);
        }
    }

    @keyframes animatedBg {
        from {
            transform: translateX(0);
        }
        to {
            transform: translateX(46px);
        }
    }
`
